export default "<a class=\"dropdown-item\" ng-repeat=\"i in items\" href=\"#\">{{i.ChecklistName}}</a>"